import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';

@Component({
  selector: 'app-modules-access',
  templateUrl: './modules-access.component.html',
  styleUrls: ['./modules-access.component.scss'],
})
export class ModulesAccessComponent implements OnInit {
  @Input() organizationId: any;
  @Input() editOrganizationId: any;
  @Input() storedFormData: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitOrganizationData: EventEmitter<void> = new EventEmitter<void>();

  @Output() showReview: EventEmitter<void> = new EventEmitter<void>();

  accessForm!: FormGroup;

  @Input() isUserEditing: boolean = false;

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.accessForm = this._fb.group({
      modules: this._fb.array([]),
      travelIntegration: this._fb.group({
        flightIntegration: [false]
      })
    });
    if(this.isUserEditing){
      this.accessForm.get("travelIntegration.flightIntegration")?.disable();
    }

    this.accessForm.valueChanges.subscribe(()=>{
      this.accessForm.markAsDirty();
      this.accessForm.markAsTouched();
    })
    if(this.storedFormData){
      this.accessForm.patchValue(this.storedFormData);
      this.storedFormData.modules.forEach((element: any) => {
        this.getModuleArray().push(this.createModuleFormGroup(element));
      });
      this.accessForm.markAsPristine();
    }
  }

  ngOnChanges(){
    this.ngOnInit();
  }

  getModuleArray(): FormArray{
    return this.accessForm.get('modules') as FormArray;
  }
  createModuleFormGroup(module:any) : FormGroup{
    let group = this._fb.group({
      name: [module?.name],
      access: [module?.access],
      startDate: [module?.startDate],
      endDate: [module?.endDate],
    });
    if(this.isUserEditing){
      group.get("access")?.disable();
    }
    return group;
  }

  async onSubmit(): Promise<boolean> {
    if (this.accessForm.valid) {
      try {
        const formData = this.accessForm.getRawValue();
        if (formData.modules && formData.modules.length > 0) {
          formData.modules = formData.modules.map((module: any) => {
            if (module.startDate) {
              const d = new Date(module.startDate);
              module.startDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T00:00:00.000Z`;
            }
            if (module.endDate) {
              const d = new Date(module.endDate);
              module.endDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T00:00:00.000Z`;
            }
            return module;
          });
        }
        this.accessForm.markAsPristine();
        this.storeFormData.emit(formData);
        this.submitOrganizationData.emit();
        return true;
      } catch (error) {
        console.error("Error while adding", error);
        return false;
      }
    } else {
      this.accessForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      return false;
    }
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.showReview.emit();
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.accessForm.dirty || this.accessForm.invalid) && this.accessForm.touched;
  }

}
